import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { AuthService, LocalService } from '../services';
import { ErrorNotificationService } from '../services/error-notification.service';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private apiService: ApiService,
    readonly authService: AuthService,
    private errorNotificationService: ErrorNotificationService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 0) {
              this.errorNotificationService.show(
                'Unable to reach the server. Please check your connection or try again later.'
              );
            }
            if (err.status === 403) {
              LocalService.flush('token');
              LocalService.flush('userProfile');
              this.authService.clearAll();
              window.open('/', '_self');
            }
            if (err.status === 503 || err.status === 404) {
              this.apiService
                .get(
                  'https://slrrwd-maintenance-api-rcdn-prod.cisco.com/api/rest/maintenance'
                )
                .subscribe((res) => {
                  if (res.underMaintenance === true) {
                    LocalService.flush('token');
                    LocalService.flush('userProfile');
                    this.authService.clearAll();
                    this.router.navigate(['/maintenance']);
                  }
                });
            }
          }
        }
      )
    );
  }
}
